export const colorArray = [
  { name: "Red", code: "rgb(208, 1, 27)" },
  { name: "Orange", code: "rgb(246, 166, 35)" },
  { name: "Yellow", code: "rgb(248, 232, 28)" },
  { name: "Green", code: "rgb(50, 205, 50)" },
  { name: "Turquoise", code: "rgb(0, 197, 205)" },
  { name: "Blue", code: "rgb(73, 144, 226)" },
  { name: "Purple", code: "rgb(144, 18, 254)" },
  { name: "Pink", code: "rgb(243, 140, 203)" },
  { name: "Black", code: "rgb(0, 0, 0)" },
  { name: "White", code: "rgb(245, 245, 221)" },
  { name: "Gray", code: "rgb(175, 176, 174)" },
  { name: "Brown", code: "rgb(137, 89, 62)" },
  { name: "Tan", code: "rgb(210, 180, 140)" },
  { name: "Gold", code: "rgb(128, 95, 1)" },
  { name: "Silver", code: "rgb(192, 192, 192)" },
  { name: "Copper", code: "rgb(184, 115, 51)" },
  { name: "Transparent", code: "rgba(0, 0, 0, 0)" },
];
